import { graphql } from '@/generated/gql'

export const GET_CONTENT_ITEM_TAGS =
    graphql(`query tagsByContentId($input: ViewMeetplaceTagModelsInput!) {
        tagsByContentId(input: $input, first: 50) {
            nodes {
                tagId
                tagName
            }
        }
    }
`)

export const SUBSCRIBE_TAGS_UPDATE =
    graphql(`subscription tagsUpdated($contentItemId: UUID!, $contentItemType: EntityType!) {
  tagsUpdated(contentItemId: $contentItemId, contentItemType: $contentItemType) {
    tags {
      tagId
      tagName
    }
  }
}`)
